var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a2a2a2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-shield",
    "data-name": "Icon awesome-user-shield",
    className: "cls-1",
    d: "M854.38,555.7l-119.8-46.8a32.25,32.25,0,0,0-23.09,0l-119.8,46.8a28.12,28.12,0,0,0-18.41,25.9c0,116.06,71.45,196.37,138.22,222.46a32.33,32.33,0,0,0,23.08,0c53.37-20.8,138.22-93,138.22-222.46A28.12,28.12,0,0,0,854.38,555.7ZM723,754.65V558l99.33,38.78C816.53,687.35,759,737.58,723,754.64ZM440.16,540A133.12,133.12,0,1,0,307,406.88,133.12,133.12,0,0,0,440.16,540ZM540,581.6a58.71,58.71,0,0,1,1.14-7.48c-2.6-.11-5.09-.84-7.82-.84H516a181,181,0,0,1-151.63,0H347A139.81,139.81,0,0,0,207.2,713.05v43.27a49.92,49.92,0,0,0,49.91,49.91H623.2a51.17,51.17,0,0,0,20-4.16A279.39,279.39,0,0,1,540,581.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.6edb671b8dee3ee0663938c4edc74123.svg";
export { ForwardRef as ReactComponent };